import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";
import "../pages/dashboard.css";
import { AUTO, CHILD, CP, FOOD, MEDICINE, PRESS, PET } from "../assets/constant";

const tabs = [
  { id: 1, icon: "fa-car", text: "Automobiles", value: AUTO },
  { id: 2, icon: "fa-utensils", text: "Food", value: FOOD },
  { id: 3, icon: "fa-medkit", text: "Medicine", value: MEDICINE },
  { id: 4, icon: "fa-bullhorn", text: "Press Release", value: PRESS },
  { id: 5, icon: "fa-child", text: "Children", value: CHILD },
  { id: 6, icon: "fa-users", text: "Consumer Products", value: CP },
  { id: 7, icon: "fa-paw", text: "Pet", value: PET },
];

const TabComponent = memo(({ updateTab, isLoading }) => {
  const [searchParams,] = useSearchParams();

  const currentTab = searchParams.get("tab");
  return (
    <div className="tab-container">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`tab-item ${currentTab === tab.value ? "active" : ""}`}
          onClick={() => !isLoading && updateTab(tab.value)}
          style={{ pointerEvents: isLoading ? "none" : "auto" }}>
          <i className={`fa ${tab.icon} tab-icon`}></i>
          <span className="tab-text">{tab.text}</span>
        </div>
      ))}
    </div>
  );
});
TabComponent.propTypes = {
  updateTab: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default TabComponent;
